import { render, staticRenderFns } from "./idxComJackpot.vue?vue&type=template&id=4a96a8e0&"
import script from "./idxComJackpot.vue?vue&type=script&lang=js&"
export * from "./idxComJackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports